import styled from "styled-components";



export const GridContainer = styled.div`
    max-width: 1220px;
    margin: 0 auto;
    position: relative;
    padding: 0px 20px;
`
export const MainButton = styled.a`
    background: linear-gradient(102.17deg, #FED15D 3.82%, #FFC85E 49.63%, #FFDF8C 94.49%);
    display: inline-block;
    padding: 10px 80px;
    border-radius: 8px;
    text-decoration: none;
    color: #464646;
    font-size: 16px;
    font-weight: 600;
    margin-top: ;
    border: 1px solid transparent;
    transition: 0.3s;
    &:hover{
        border-color: #FED15D;
        color: #FED15D;
        background: transparent;
        transition: 0.3s;
    }
`